import { colord } from 'colord';
import { GmgTheme } from '@gmg/gmg-react-components';

export const getHighlightedColor = (hex: string, theme: GmgTheme): string =>
    theme.type === 'light'
        ? colord(hex).darken(2).toHex()
        : colord(hex).lighten(4).toHex();
